import config from "config/config.js";

const getAttributes = () => {
  // const endpoint = `http://localhost:3000/api/categories/all`;
  // const endpoint = `https://www.foodiestrip.com/api/categories/all`;
  const endpoint = `${config.baseUrl}/api/categories`;
  const options = {
    method: "get",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  };
  return fetch(endpoint, options)
    .then(response => response.json())
    .then(res => {
      return res;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errrr", e);
    });
};

export default getAttributes;
